import "malihu-custom-scrollbar-plugin";

export class Menu {
  /**
   *
   * @param {*} dataEntry
   */
  constructor(dataEntry) {
    this.dataEntry = dataEntry;
  }

  /**
   *
   */
  init() {
    this.x_navigation_onresize();
    this.listener();
    this.toggleStageInfos();
  }

  /**
   *
   */
  listener() {
    let toggleButton = document.querySelector(".x-navigation-minimize ");
    let navigation = document.querySelector(".page-sidebar .x-navigation");

    if (toggleButton === null) {
      return;
    }

    if ($(".page-navigation-toggled").length > 0) {
      this.x_navigation_minimize("close");
    }

    if ($(".page-navigation-toggled-hover").length > 0) {
      $(".page-sidebar").hover(
        function () {
          $(".x-navigation-minimize").trigger("click");
        },
        function () {
          $(".x-navigation-minimize").trigger("click");
        }
      );
    }

    $(".x-navigation-minimize").click(() => {
      if ($(".page-sidebar .x-navigation").hasClass("x-navigation-minimized")) {
        $(".page-container").removeClass("page-navigation-toggled");
        this.x_navigation_minimize("open");
      } else {
        $(".page-container").addClass("page-navigation-toggled");
        this.x_navigation_minimize("close");
      }

      // window.onresize();

      return false;
    });

    $(".x-navigation  li > a").click((e) => {
      var li = $(e.currentTarget).parent("li");
      var ul = li.parent("ul");

      ul.find(" > li").not(li).removeClass("active");
    });

    $(".x-navigation li").click((e) => {
      e.stopPropagation();

      var li = $(e.currentTarget);

      if (
        li.children("ul").length > 0 ||
        li.children(".panel").length > 0 ||
        $(e.currentTarget).hasClass("xn-profile") > 0
      ) {
        if (li.hasClass("active")) {
          li.removeClass("active");
          li.find("li.active").removeClass("active");
        } else li.addClass("active");

        // window.onresize();

        if ($(e.currentTarget).hasClass("xn-profile") > 0) return true;
        else return false;
      }
    });

    $(".xn-search").on("click", (e) => {
      $(e.currentTarget).find("input").focus();
    });

    toggleButton.addEventListener("click", () => {
      let action = "open";

      if (navigation.classList.contains("x-navigation-minimized")) {
        action = "close";
      }

      this.toggle(toggleButton, action);
      this.setState(action);

      return false;
    });

    const languages = document.querySelectorAll("[data-switch-language]");
    languages.forEach((language) => {
      language.addEventListener("click", (e) => {
        const lang = e.currentTarget.dataset.switchLanguage;

        fetch(`/ajax/switchLanguage/${lang}`).then(() => location.reload());
      });
    });
  }

  /**
   *
   */
  x_navigation_onresize() {
    let inner_port = window.innerWidth || $(document).width();

    if (inner_port < 1025) {
      $(".page-sidebar .x-navigation").removeClass("x-navigation-minimized");
      $(".page-container").removeClass("page-container-wide");
      $(".page-sidebar .x-navigation li.active").removeClass("active");

      $(".x-navigation-horizontal").each((el) => {
        if (!$(el).hasClass("x-navigation-panel")) {
          $(".x-navigation-horizontal").addClass("x-navigation-h-holder").removeClass("x-navigation-horizontal");
        }
      });
    } else {
      if ($(".page-navigation-toggled").length > 0) {
        this.x_navigation_minimize("close");
      }

      $(".x-navigation-h-holder").addClass("x-navigation-horizontal").removeClass("x-navigation-h-holder");
    }
  }

  /**
   *
   * @param action
   */
  x_navigation_minimize(action) {
    if (action === "open") {
      $(".page-container").removeClass("page-container-wide");
      $(".page-sidebar .x-navigation").removeClass("x-navigation-minimized");
      $(".x-navigation-minimize").find(".fa").removeClass("fa-indent").addClass("fa-dedent");
      $(".page-sidebar.scroll").mCustomScrollbar("update");
      $(".application-information").show();
    }

    if (action === "close") {
      $(".page-container").addClass("page-container-wide");
      $(".page-sidebar .x-navigation").addClass("x-navigation-minimized");
      $(".x-navigation-minimize").find(".fa").removeClass("fa-dedent").addClass("fa-indent");
      $(".page-sidebar.scroll").mCustomScrollbar("disable", true);
      $(".application-information").hide();
    }

    $(".x-navigation li.active").removeClass("active");
  }

  /**
   * stores the toggle state of the sidebar in the session
   */
  setState(action) {
    fetch("/ajax/toggleNavigation", {
      method: "POST",
      body: JSON.stringify({ toggle: action }),
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  /**
   * opens the current's submenu and highlights active menu items
   */
  setCurrentActive() {
    let currents = document.querySelectorAll(".current");

    for (let i = 0; i < currents.length; i++) {
      if (!currents[i].classList.contains("active")) {
        currents[i].classList.add("active");
      }
    }
  }

  /**
   * toggles the sidebar
   *
   * @param toggleButton
   * @param action
   */
  toggle(toggleButton, action) {
    let toggleButtonIcon = toggleButton.querySelector(".fa");

    if (action === "open") {
      toggleButtonIcon.classList.remove("fa-indent");
      toggleButtonIcon.classList.add("fa-dedent");
      this.setCurrentActive();
    }

    if (action === "close") {
      toggleButtonIcon.classList.remove("fa-dedent");
      toggleButtonIcon.classList.add("fa-indent");
    }
  }

  /**
   *
   * @param {number} count
   */
  displayPendingCount(count) {
    document.querySelector("#pending_count").innerText = count;
  }

  /**
   * toggles stage infos (e.g. the stage label in the top left corner)
   */
  toggleStageInfos() {
    $(".x-navigation-minimize").on("click", () => {
      var applicationInformation = $("#application-information");
      var applicationEnvironment = $("#application-environment");

      if ($("#_body > div.page-container").hasClass("page-navigation-toggled")) {
        applicationInformation.hide();
        applicationEnvironment.hide();
      } else {
        applicationInformation.show();
        applicationEnvironment.show();
      }
    });
  }
}
